import React from 'react';
import classnames from 'classnames';
import styles from '../../../styles/components/chart-legend.module.scss';

export const LegendItem = React.memo(({ label, value, color, className }) => {
  return (
    <li className={classnames(styles.item, className)} style={{ color }}>
      <div>
        <p className={styles.label}>{label}</p>
        <p className={styles.value}>{value}</p>
      </div>
    </li>
  );
});

export const Legend = React.memo(({ total, children, className }) => (
  <div className={classnames(styles.container, className)}>
    <ul>{children}</ul>
    <div className={styles.total}>
      <p className={styles.label}>{total?.label ?? 'total'}</p>
      <p className={styles.value}>{total?.value ?? total ?? 0}</p>
    </div>
  </div>
));
